import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const StatsTable = ({ data, allColumns }) => {
  const [hoveredRow, setHoveredRow] = useState(null); // Track the hovered row index
  const columns = Object.keys(data[0]);

  const columnStyles = {
    fontWeight: "600",
    textAlign: "center",
    padding: "8px",
    borderBottom: "1px solid #ddd",
  };

  const firstColumnStyles = {
    ...columnStyles,
    borderLeft: "1px solid #ddd",
  };

  const lastColumnStyles = {
    ...columnStyles,
    borderRight: "1px solid #ddd",
  };

  const stickyRowStyles = {
    position: "sticky",
    top: 0,
    zIndex: 2,
    backgroundColor: "#152C73",
    color: "white",
    fontWeight: "700",
    textAlign: "center",
    padding: "10px",
    borderBottom: "1px solid #ddd",
    borderLeft: "1px solid #ddd",
    borderRight: "1px solid #ddd",
  };

  const tableContainerStyles = {
    margin: "20px auto",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    maxWidth: "90vw",
    overflowX: "auto",
    whiteSpace: "nowrap",
  };

  const rowStyles = (index) => ({
    backgroundColor:
      hoveredRow === index
        ? "#D1D5DB" // Hover color
        : index % 2 === 0
        ? "#E3E7ED"
        : "#F1F5F9", // Alternating colors
    cursor: "pointer", // Change cursor to pointer on hover
  });

  return (
    <TableContainer component={Paper} style={tableContainerStyles}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={stickyRowStyles}>Features</TableCell>
            {columns.map((columnName, index) => (
              <TableCell
                key={index}
                style={{
                  ...stickyRowStyles,
                  ...(index === 0 && { borderLeft: "1px solid #ddd" }),
                  ...(index === columns.length - 1 && { borderRight: "1px solid #ddd" }),
                }}
              >
                {columnName}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow
              key={rowIndex}
              style={rowStyles(rowIndex)}
              onMouseEnter={() => setHoveredRow(rowIndex)} // Highlight row on hover
              onMouseLeave={() => setHoveredRow(null)} // Reset highlight on mouse leave
            >
              <TableCell style={firstColumnStyles}>{allColumns[rowIndex]}</TableCell>
              {columns.map((columnName, columnIndex) => (
                <TableCell
                  key={columnIndex}
                  style={
                    columnIndex === columns.length - 1
                      ? lastColumnStyles
                      : columnIndex === 0
                      ? firstColumnStyles
                      : columnStyles
                  }
                >
                  {row[columnName]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StatsTable;
